import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { FileDown } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Stat, inr, saveFile } from "./shared";

export function Analytics() {
  const [cid, setCid] = useState("");
  const camps = useQuery({ queryKey: ["ob", "camps"], queryFn: async () => (await api.get("/outbound/campaigns")).data });
  const q = useQuery({ queryKey: ["ob", "analytics", cid], queryFn: async () => (await api.get(`/outbound/analytics?campaign_id=${cid}`)).data, refetchInterval: 10000 });
  const a = q.data;
  return (
    <div className="space-y-3" data-testid="ob-analytics">
      <div className="flex flex-wrap items-center gap-2">
        <select value={cid} onChange={(e) => setCid(e.target.value)} className="rounded border px-2 py-1 text-sm" data-testid="ob-an-filter">
          <option value="">All campaigns</option>{(camps.data || []).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select>
        <Button size="sm" variant="outline" onClick={() => saveFile(`/outbound/analytics/export?campaign_id=${cid}`, "pawkt_campaign_report.csv").catch((e) => toast.error(apiErr(e)))}
          data-testid="ob-an-export"><FileDown className="mr-1 h-4 w-4" />Export CSV</Button>
      </div>
      {!a ? <p className="text-xs text-slate-500">Loading…</p> : <>
        <p className="text-xs text-slate-500">Business results (recorded calls)</p>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-6">
          <Stat k="Leads" v={a.leads} id="ob-an-leads" /><Stat k="Eligible" v={a.eligible} id="ob-an-eligible" /><Stat k="Ineligible" v={a.ineligible} id="ob-an-ineligible" />
          <Stat k="Attempted" v={a.attempted} id="ob-an-attempted" /><Stat k="Connected" v={a.connected} id="ob-an-connected" /><Stat k="Completed" v={a.completed} id="ob-an-completed" />
        </div>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-6">
          {Object.entries(a.labels).map(([k, l]) => <Stat key={k} k={l} v={a.outcomes[k]} id={`ob-an-${k}`} />)}
        </div>
        <p className="text-xs text-slate-500">Usage and cost</p>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-5">
          <Stat k="Avg duration" v={`${a.avg_duration_s}s`} id="ob-an-avg" /><Stat k="AI minutes" v={a.ai_minutes} id="ob-an-minutes" />
          <Stat k="Actual cost" v={inr(a.actual_cost_paise)} id="ob-an-cost" /><Stat k="Estimated (reserved)" v={inr(a.estimated_reserved_paise)} id="ob-an-reserved" />
          <Stat k="Budget" v={inr(a.budget_paise)} id="ob-an-budget" />
        </div>
        <p className="text-xs text-slate-500" data-testid="ob-an-note">{a.mode === "mock" ? "Preview: calls are mocked. " : ""}{a.note}</p>
      </>}
    </div>
  );
}
